import {RouteDefinition} from '../../../../routes';
import {WiFiListScreen} from './WifiListScreen';
import {WiFiConnectScreen} from './WiFiConnectScreen';

export const WiFiSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/gateway/:id/wifi',
        component: WiFiListScreen,
    },
    {
        routerLink: '/settings/gateway/:gatewayId/wifi/:id',
        component: WiFiConnectScreen,
    },
];
